import { render, staticRenderFns } from "./AwaitingIRSPayments.vue?vue&type=template&id=0e9bef2c&scoped=true&"
import script from "./AwaitingIRSPayments.vue?vue&type=script&lang=js&"
export * from "./AwaitingIRSPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9bef2c",
  null
  
)

export default component.exports